module.exports = __webpack_public_path__ + "static/media/logo-invillia-instation.3cd44f66.svg";